const MAX_WIDTH = '2400px'
const NAV_HEIGHT = '48px'
const SIDEBAR_WIDTH = '200px'
const FOOTER_HEIGHT = '35px'

export { MAX_WIDTH, NAV_HEIGHT, SIDEBAR_WIDTH, FOOTER_HEIGHT }
